module.exports = __webpack_public_path__ + "static/media/bs.30bbf0ec.svg";